import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreChangeOrderActions from './tyre-change-order.action';
import { TyreChangeOrderService } from './tyre-change-order.service';
import { BannerService } from '../../shared/services/banner.service';
import * as TyreChangeOrderModels from '../../models/tyre-change-order/tyre-change-order';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as OrderTypeModels from '../../models/order/orderType';
import { TyreChangeOrderSearchModel } from '../../models/tyre-change-order/tyre-change-orderSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import * as Models from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';


export interface TyreChangeOrderStateModel {
    OrderStatus: OrderStatusModels.OrderStatusListModel;
    OrderList: TyreChangeOrderModels.TyreChangeOrderListModel;
    Order: Models.Response<TyreChangeOrderModels.TyreChangeOrderModel>;
    Search: TyreChangeOrderSearchModel;
    ProcessingReportFiltered: number;
    ProcessingReportNFM: number;
}

class DictionaryKeys {
  public static readonly OrderStatus = "TyreChangeOrderStatus";
}

@State<TyreChangeOrderStateModel>({
    name: 'tyreChangeOrderState',
    defaults: {
      OrderStatus: null,
      OrderList: null,
      Search: null,
      Order: null,
      ProcessingReportFiltered: null,
      ProcessingReportNFM: null
    }
  })

  @Injectable()

  export class TyreChangeOrderState {

    constructor(
      private helperService: HelperService,
      private tyreChangeOrderService: TyreChangeOrderService,
      private bannerService: BannerService,
      private storageService: StorageService
  ) { }


  @Selector()
  static OrderStatus(state: TyreChangeOrderStateModel) {
    return state.OrderStatus;
  }


  @Selector()
  static OrderList(state: TyreChangeOrderStateModel) {
    return state.OrderList;
  }

  @Selector()
  static Order(state: TyreChangeOrderStateModel) {
    return state.Order;
  }

  @Selector()
  static OrderSearch(state: TyreChangeOrderStateModel) {
    return state.Search;
  }

  @Selector()
  static ProcessingReportFiltered(state: TyreChangeOrderStateModel) {
    return state.ProcessingReportFiltered;
  }

  @Selector()
  static ProcessingReportNFM(state: TyreChangeOrderStateModel) {
    return state.ProcessingReportNFM;
  }


  @Action(TyreChangeOrderActions.GetList)
  GetList(
    context: StateContext<TyreChangeOrderStateModel>,
    action: TyreChangeOrderActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy zleceń wymiany opony.';

    context.setState(
      patch({
        OrderList: null
      })
    );

    this.tyreChangeOrderService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            OrderList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('OrderActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreChangeOrderActions.SetSearch)
  SetSearch(
    context: StateContext<TyreChangeOrderStateModel>,
    action: TyreChangeOrderActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreChangeOrderActions.GetList(action.Search));
  }

  @Action(TyreChangeOrderActions.SetListPage)
  SetListPage(
    context: StateContext<TyreChangeOrderStateModel>,
    action: TyreChangeOrderActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreChangeOrderActions.GetList(action.Search));
  }

  @Action(TyreChangeOrderActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreChangeOrderStateModel>
  ) {

    const state = context.getState();

    const search = new TyreChangeOrderSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreChangeOrderActions.GetList(search));
  }

  @Action(TyreChangeOrderActions.GetStatusDictionary)
  GetStatusDictionary(
    context: StateContext<TyreChangeOrderStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statusów zleceń relokacji opon.';

    let storageKey = DictionaryKeys.OrderStatus;

    context.setState(
      patch({
        OrderStatus: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.OrderStatus) {
      this.tyreChangeOrderService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              OrderStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreOrderActions.GetStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreChangeOrderActions.DisposeSearch)
  DisposeSearch(
      context: StateContext<TyreChangeOrderStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(TyreChangeOrderActions.Set)
  Set(
    context: StateContext<TyreChangeOrderStateModel>,
    action: TyreChangeOrderActions.Set
  ) {
    const errorMessage = 'Błąd zapisu zmian zlecenia zmiany opon.';

    this.tyreChangeOrderService.set(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do zlecenia zmiany opon ' + ret.Item.Number + '.');

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreChangeOrderActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreChangeOrderActions.Get)
  Get(
    context: StateContext<TyreChangeOrderStateModel>,
    action: TyreChangeOrderActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia zmiany opon.';

    this.tyreChangeOrderService.get(action.OrderId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreChangeOrderActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}

